import { render, staticRenderFns } from "./CommunicationsTable.vue?vue&type=template&id=ceba53be&scoped=true"
import script from "./CommunicationsTable.vue?vue&type=script&lang=js"
export * from "./CommunicationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceba53be",
  null
  
)

export default component.exports